exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top[data-v-c613c216] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.top .title[data-v-c613c216] {\n  display: flex;\n  align-items: center;\n}\n.top .title h1[data-v-c613c216] {\n  margin-left: 20px;\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 1em;\n}\n.box[data-v-c613c216] {\n  margin: 30px 0;\n}\nform .field[data-v-c613c216] {\n  margin-top: 20px;\n}\nform .permission-options[data-v-c613c216] {\n  padding-left: 20px;\n}", ""]);

// exports
